export const ISLANDS = [
  {
    code: 'GP',
    name: 'Guadeloupe',
    center: [16.265, -61.551],
    zoom: 10,
    cities: [
      { name: 'Pointe-à-Pitre',        lat: 16.2408, lng: -61.5335 },
      { name: 'Basse-Terre',            lat: 15.9986, lng: -61.7243 },
      { name: 'Les Abymes',             lat: 16.2667, lng: -61.5000 },
      { name: 'Le Gosier',              lat: 16.2000, lng: -61.4833 },
      { name: 'Sainte-Anne',            lat: 16.2167, lng: -61.3833 },
      { name: 'Le Moule',               lat: 16.3333, lng: -61.3500 },
      { name: 'Capesterre-Belle-Eau',   lat: 15.9333, lng: -61.5667 },
      { name: 'Baie-Mahault',           lat: 16.2667, lng: -61.5833 },
      { name: 'Lamentin',               lat: 16.2667, lng: -61.6333 },
      { name: 'Sainte-Rose',            lat: 16.3333, lng: -61.7000 },
      { name: 'Bouillante',             lat: 16.1333, lng: -61.7667 },
      { name: 'Deshaies',               lat: 16.3000, lng: -61.8000 },
      { name: 'Port-Louis',             lat: 16.4167, lng: -61.5333 },
      { name: 'Anse-Bertrand',          lat: 16.4833, lng: -61.5000 },
      { name: 'Saint-François',         lat: 16.2500, lng: -61.2667 },
    ],
  },
  {
    code: 'MQ',
    name: 'Martinique',
    center: [14.641, -61.024],
    zoom: 10,
    cities: [
      { name: 'Fort-de-France',   lat: 14.6028, lng: -61.0731 },
      { name: 'Le Lamentin',      lat: 14.6167, lng: -60.9833 },
      { name: 'Le Robert',        lat: 14.6833, lng: -60.9333 },
      { name: 'Sainte-Marie',     lat: 14.7833, lng: -60.9833 },
      { name: 'Le François',      lat: 14.6167, lng: -60.9000 },
      { name: 'Saint-Joseph',     lat: 14.6667, lng: -61.0167 },
      { name: 'Le Marin',         lat: 14.4667, lng: -60.8833 },
      { name: 'Sainte-Anne',      lat: 14.4333, lng: -60.8833 },
      { name: 'La Trinité',       lat: 14.7333, lng: -60.9667 },
      { name: 'Le Vauclin',       lat: 14.5500, lng: -60.8333 },
      { name: 'Rivière-Pilote',   lat: 14.4833, lng: -60.9167 },
      { name: 'Rivière-Salée',    lat: 14.5333, lng: -60.9500 },
      { name: 'Les Trois-Îlets',  lat: 14.5333, lng: -61.0167 },
      { name: 'Ducos',            lat: 14.5667, lng: -60.9833 },
      { name: 'Le Diamant',       lat: 14.4667, lng: -61.0167 },
    ],
  },
  {
    code: 'GF',
    name: 'Guyane française',
    center: [3.933, -53.126],
    zoom: 7,
    cities: [
      { name: 'Cayenne',                   lat:  4.9224, lng: -52.3135 },
      { name: 'Saint-Laurent-du-Maroni',   lat:  5.4978, lng: -54.0317 },
      { name: 'Kourou',                    lat:  5.1600, lng: -52.6500 },
      { name: 'Matoury',                   lat:  4.8500, lng: -52.3167 },
      { name: 'Rémire-Montjoly',           lat:  4.8833, lng: -52.2833 },
      { name: 'Mana',                      lat:  5.6667, lng: -53.7833 },
      { name: 'Saint-Georges',             lat:  3.8833, lng: -51.8000 },
    ],
  },
  {
    code: 'MF',
    name: 'Saint-Martin',
    center: [18.075, -63.052],
    zoom: 12,
    cities: [
      { name: 'Marigot',                lat: 18.0681, lng: -63.0822 },
      { name: 'Grand-Case',             lat: 18.1000, lng: -63.0500 },
      { name: "Quartier d'Orléans",     lat: 18.0500, lng: -63.0167 },
      { name: 'Cul-de-Sac',             lat: 18.1000, lng: -63.0167 },
      { name: 'Sandy Ground',           lat: 18.0833, lng: -63.0833 },
    ],
  },
  {
    code: 'BL',
    name: 'Saint-Barthélemy',
    center: [17.896, -62.849],
    zoom: 13,
    cities: [
      { name: 'Gustavia',   lat: 17.8958, lng: -62.8497 },
      { name: 'Saint-Jean', lat: 17.9000, lng: -62.8333 },
      { name: 'Lorient',    lat: 17.9000, lng: -62.8167 },
      { name: 'Flamands',   lat: 17.9167, lng: -62.8500 },
      { name: 'Corossol',   lat: 17.9000, lng: -62.8667 },
    ],
  },
  {
    code: 'HT',
    name: 'Haïti',
    center: [18.971, -72.285],
    zoom: 8,
    cities: [
      { name: 'Port-au-Prince',  lat: 18.5392, lng: -72.3288 },
      { name: 'Cap-Haïtien',     lat: 19.7575, lng: -72.2014 },
      { name: 'Gonaïves',        lat: 19.4500, lng: -72.6833 },
      { name: 'Saint-Marc',      lat: 19.1167, lng: -72.7000 },
      { name: 'Jacmel',          lat: 18.2333, lng: -72.5333 },
      { name: 'Les Cayes',       lat: 18.2000, lng: -73.7500 },
      { name: 'Jérémie',         lat: 18.6500, lng: -74.1167 },
      { name: 'Hinche',          lat: 19.1500, lng: -72.0167 },
      { name: 'Miragoâne',       lat: 18.4500, lng: -73.0833 },
    ],
  },
  {
    code: 'DO',
    name: 'République Dominicaine',
    center: [18.735, -70.163],
    zoom: 8,
    cities: [
      { name: 'Saint-Domingue',        lat: 18.4861, lng: -69.9312 },
      { name: 'Santiago',              lat: 19.4500, lng: -70.6833 },
      { name: 'San Pedro de Macorís',  lat: 18.4500, lng: -69.3000 },
      { name: 'La Romana',             lat: 18.4167, lng: -68.9667 },
      { name: 'San Cristóbal',         lat: 18.4167, lng: -70.1000 },
      { name: 'Puerto Plata',          lat: 19.7956, lng: -70.6889 },
      { name: 'Higüey',                lat: 18.6167, lng: -68.7000 },
      { name: 'Baní',                  lat: 18.2833, lng: -70.3333 },
    ],
  },
  {
    code: 'CU',
    name: 'Cuba',
    center: [21.521, -77.781],
    zoom: 7,
    cities: [
      { name: 'La Havane',        lat: 23.1136, lng: -82.3666 },
      { name: 'Santiago de Cuba', lat: 20.0228, lng: -75.8211 },
      { name: 'Camagüey',         lat: 21.3797, lng: -77.9161 },
      { name: 'Holguín',          lat: 20.8897, lng: -76.2628 },
      { name: 'Santa Clara',      lat: 22.4064, lng: -79.9653 },
      { name: 'Guantánamo',       lat: 20.1428, lng: -75.2103 },
      { name: 'Trinidad',         lat: 21.8022, lng: -79.9839 },
      { name: 'Varadero',         lat: 23.1533, lng: -81.2536 },
      { name: 'Cienfuegos',       lat: 22.1436, lng: -80.4428 },
    ],
  },
  {
    code: 'JM',
    name: 'Jamaïque',
    center: [18.109, -77.297],
    zoom: 9,
    cities: [
      { name: 'Kingston',      lat: 17.9970, lng: -76.7936 },
      { name: 'Montego Bay',   lat: 18.4762, lng: -77.8939 },
      { name: 'Spanish Town',  lat: 17.9912, lng: -76.9556 },
      { name: 'Portmore',      lat: 17.9500, lng: -76.8833 },
      { name: 'Ocho Rios',     lat: 18.4089, lng: -77.1036 },
      { name: 'Mandeville',    lat: 18.0425, lng: -77.5036 },
      { name: 'Negril',        lat: 18.2661, lng: -78.3522 },
      { name: 'Port Antonio',  lat: 18.1725, lng: -76.4508 },
    ],
  },
  {
    code: 'PR',
    name: 'Porto Rico',
    center: [18.220, -66.590],
    zoom: 9,
    cities: [
      { name: 'San Juan',   lat: 18.4655, lng: -66.1057 },
      { name: 'Bayamón',    lat: 18.3794, lng: -66.1633 },
      { name: 'Carolina',   lat: 18.3808, lng: -65.9575 },
      { name: 'Ponce',      lat: 18.0111, lng: -66.6141 },
      { name: 'Caguas',     lat: 18.2342, lng: -66.0350 },
      { name: 'Guaynabo',   lat: 18.3575, lng: -66.1100 },
      { name: 'Mayagüez',   lat: 18.2011, lng: -67.1397 },
      { name: 'Humacao',    lat: 18.1494, lng: -65.8278 },
    ],
  },
  {
    code: 'TT',
    name: 'Trinité-et-Tobago',
    center: [10.691, -61.222],
    zoom: 10,
    cities: [
      { name: 'Port of Spain',  lat: 10.6549, lng: -61.5019 },
      { name: 'San Fernando',   lat: 10.2800, lng: -61.4667 },
      { name: 'Chaguanas',      lat: 10.5167, lng: -61.4000 },
      { name: 'Arima',          lat: 10.6333, lng: -61.2833 },
      { name: 'Scarborough',    lat: 11.1833, lng: -60.7333 },
    ],
  },
  {
    code: 'BB',
    name: 'Barbade',
    center: [13.193, -59.543],
    zoom: 11,
    cities: [
      { name: 'Bridgetown',    lat: 13.0975, lng: -59.6167 },
      { name: 'Speightstown',  lat: 13.2500, lng: -59.6500 },
      { name: 'Holetown',      lat: 13.1833, lng: -59.6333 },
      { name: 'Oistins',       lat: 13.0667, lng: -59.5500 },
      { name: 'Bathsheba',     lat: 13.2000, lng: -59.5333 },
    ],
  },
  {
    code: 'LC',
    name: 'Sainte-Lucie',
    center: [13.909, -60.978],
    zoom: 11,
    cities: [
      { name: 'Castries',    lat: 14.0101, lng: -61.0000 },
      { name: 'Vieux Fort',  lat: 13.7167, lng: -60.9500 },
      { name: 'Soufrière',   lat: 13.8500, lng: -61.0500 },
      { name: 'Gros Islet',  lat: 14.0833, lng: -60.9500 },
      { name: 'Micoud',      lat: 13.8167, lng: -60.9000 },
    ],
  },
  {
    code: 'VC',
    name: 'Saint-Vincent-et-les-Grenadines',
    center: [13.252, -61.198],
    zoom: 11,
    cities: [
      { name: 'Kingstown',       lat: 13.1600, lng: -61.2247 },
      { name: 'Georgetown',      lat: 13.2667, lng: -61.1167 },
      { name: 'Barrouallie',     lat: 13.2333, lng: -61.2667 },
      { name: 'Chateaubelair',   lat: 13.2833, lng: -61.2667 },
    ],
  },
  {
    code: 'GD',
    name: 'Grenade',
    center: [12.116, -61.679],
    zoom: 12,
    cities: [
      { name: "Saint George's",  lat: 12.0561, lng: -61.7486 },
      { name: 'Grenville',       lat: 12.1167, lng: -61.6167 },
      { name: 'Victoria',        lat: 12.2000, lng: -61.7000 },
      { name: 'Gouyave',         lat: 12.1667, lng: -61.7333 },
    ],
  },
  {
    code: 'DM',
    name: 'Dominique',
    center: [15.415, -61.371],
    zoom: 11,
    cities: [
      { name: 'Roseau',        lat: 15.3017, lng: -61.3881 },
      { name: 'Portsmouth',    lat: 15.5722, lng: -61.4594 },
      { name: 'Marigot',       lat: 15.5333, lng: -61.3167 },
      { name: 'Castle Bruce',  lat: 15.4333, lng: -61.2833 },
    ],
  },
  {
    code: 'AG',
    name: 'Antigua-et-Barbuda',
    center: [17.060, -61.796],
    zoom: 11,
    cities: [
      { name: "Saint John's",  lat: 17.1175, lng: -61.8456 },
      { name: 'All Saints',    lat: 17.0667, lng: -61.8000 },
      { name: 'Liberta',       lat: 17.0333, lng: -61.7833 },
      { name: 'Codrington',    lat: 17.6333, lng: -61.8167 },
      { name: 'Bolans',        lat: 17.0500, lng: -61.8500 },
    ],
  },
  {
    code: 'KN',
    name: 'Saint-Kitts-et-Nevis',
    center: [17.357, -62.783],
    zoom: 12,
    cities: [
      { name: 'Basseterre',       lat: 17.2948, lng: -62.7261 },
      { name: 'Charlestown',      lat: 17.1369, lng: -62.6189 },
      { name: 'Sandy Point Town', lat: 17.3667, lng: -62.8333 },
      { name: 'Dieppe Bay',       lat: 17.4167, lng: -62.8333 },
    ],
  },
  {
    code: 'AW',
    name: 'Aruba',
    center: [12.521, -69.968],
    zoom: 12,
    cities: [
      { name: 'Oranjestad',  lat: 12.5186, lng: -70.0358 },
      { name: 'Sint Nicolaas', lat: 12.4333, lng: -69.9333 },
      { name: 'Noord',       lat: 12.5667, lng: -70.0333 },
      { name: 'Santa Cruz',  lat: 12.5167, lng: -69.9667 },
      { name: 'Paradera',    lat: 12.5000, lng: -70.0333 },
    ],
  },
  {
    code: 'CW',
    name: 'Curaçao',
    center: [12.169, -68.990],
    zoom: 11,
    cities: [
      { name: 'Willemstad',   lat: 12.1084, lng: -68.9335 },
      { name: 'Barber',       lat: 12.1667, lng: -69.0333 },
      { name: 'Sint Michiel', lat: 12.1667, lng: -68.9833 },
      { name: 'Lagun',        lat: 12.3333, lng: -69.1500 },
      { name: 'Westpunt',     lat: 12.3667, lng: -69.1500 },
    ],
  },
  {
    code: 'SX',
    name: 'Sint Maarten',
    center: [18.035, -63.072],
    zoom: 13,
    cities: [
      { name: 'Philipsburg',          lat: 18.0178, lng: -63.0547 },
      { name: 'Cole Bay',             lat: 18.0333, lng: -63.0833 },
      { name: 'Simpson Bay',          lat: 18.0333, lng: -63.1000 },
      { name: 'Lower Prince Quarter', lat: 18.0500, lng: -63.0833 },
    ],
  },
  {
    code: 'BS',
    name: 'Bahamas',
    center: [25.025, -77.396],
    zoom: 8,
    cities: [
      { name: 'Nassau',       lat: 25.0443, lng: -77.3504 },
      { name: 'Freeport',     lat: 26.5333, lng: -78.7000 },
      { name: 'Marsh Harbour', lat: 26.5500, lng: -77.0500 },
      { name: 'George Town',  lat: 23.5167, lng: -75.7667 },
      { name: 'Andros Town',  lat: 24.7000, lng: -77.7667 },
    ],
  },
  {
    code: 'VI',
    name: 'Îles Vierges (É-U)',
    center: [18.335, -64.896],
    zoom: 11,
    cities: [
      { name: 'Charlotte Amalie',  lat: 18.3419, lng: -64.9307 },
      { name: 'Christiansted',     lat: 17.7461, lng: -64.7022 },
      { name: 'Cruz Bay',          lat: 18.3308, lng: -64.7939 },
      { name: 'Frederiksted',      lat: 17.7133, lng: -64.8842 },
    ],
  },
  {
    code: 'VG',
    name: 'Îles Vierges britanniques',
    center: [18.430, -64.630],
    zoom: 12,
    cities: [
      { name: 'Road Town',     lat: 18.4272, lng: -64.6200 },
      { name: 'Spanish Town',  lat: 18.4500, lng: -64.4333 },
      { name: 'The Valley',    lat: 18.7267, lng: -63.9481 },
      { name: 'Cane Garden Bay', lat: 18.4500, lng: -64.6667 },
    ],
  },
  {
    code: 'KY',
    name: 'Îles Caïmans',
    center: [19.313, -81.254],
    zoom: 11,
    cities: [
      { name: 'George Town',   lat: 19.2869, lng: -81.3675 },
      { name: 'West Bay',      lat: 19.3500, lng: -81.4000 },
      { name: 'Bodden Town',   lat: 19.2833, lng: -81.2500 },
      { name: 'East End',      lat: 19.3000, lng: -81.1000 },
    ],
  },
];

export const ISLAND_BY_CODE = Object.fromEntries(ISLANDS.map((i) => [i.code, i]));

/** Returns { lat, lng } for a city name within an island, or null. */
export function getCityCoords(island, cityName) {
  const found = island.cities.find((c) => c.name === cityName);
  return found ? { lat: found.lat, lng: found.lng } : null;
}
